import { Alert, AlertTitle, Button, IconButton } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { oidButtonSX } from "../../pages/user/Account/components/IdentitiesTab";
import { BCPXmark } from "../icons/bcp/BCPIcons";
import { GWWarhammerIcon } from "../icons/gw/GWIcons";
import {
  getLocalStorage,
  setLocalStorage
} from "../layout/cookies/CookieFunctions";

const IS_GW =
  getEnvironmentVariable("IS_GW") === "true" ||
  getEnvironmentVariable("COMPANY_FLAG") === "gw";

export function MyWarhammerLinkButton(props) {
  const buttonSX = oidButtonSX("GamesWorkshop");
  const { fullWidth, disabled, target } = props;

  return (
    <Button
      variant="contained"
      color="warning"
      sx={{ textTransform: "unset", mt: 2, ...buttonSX }}
      fullWidth={fullWidth}
      startIcon={<GWWarhammerIcon />}
      href="/account?active_tab=identities"
      disabled={disabled}
      target={target}
    >
      Link with My Warhammer
    </Button>
  );
}

export default function GWMyWarhammerAlert(props) {
  const lastDismissed = getLocalStorage("GWMyWarhammerDismissed");

  const [hidden, setHidden] = useState(lastDismissed ? true : false);

  // If user has dismissed the alert, show it again after 12 hours
  useEffect(() => {
    if (lastDismissed) {
      const lastDismissedDate = moment(lastDismissed);
      const now = moment();

      if (now.diff(lastDismissedDate, "hours") >= 12) {
        setHidden(false);
      } else {
        setHidden(true);
      }
    }
  }, [lastDismissed, hidden]);

  return (
    <>
      {!hidden && (
        <Alert
          icon={false}
          color={IS_GW ? "warning" : "info"}
          sx={{ textAlign: "center", justifyContent: "center" }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{
              position: "absolute",
              top: "60px",
              right: "4px"
            }}
            onClick={() => {
              setLocalStorage("GWMyWarhammerDismissed", moment().toISOString());
              setHidden(true);
            }}
          >
            <BCPXmark />
          </IconButton>
          <AlertTitle sx={{ textTransform: "uppercase" }}>
            Join My Warhammer!
          </AlertTitle>
          You can now link your BCP Account with your My Warhammer account.
          <MyWarhammerLinkButton fullWidth />
        </Alert>
      )}
    </>
  );
}
